import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m24.534 5.877-6.25-5A1.77 1.77 0 0 0 17.19.5H3.125c-.83.002-1.624.267-2.21.737C.33 1.707.002 2.342 0 3.005v19.996c0 .662.33 1.298.915 1.767.586.469 1.381.732 2.21.732h18.75c.41 0 .817-.065 1.196-.19a3.29 3.29 0 0 0 1.014-.542c.29-.232.52-.508.677-.81.157-.304.238-.63.238-.957V6.754c-.006-.33-.173-.645-.466-.877ZM17.19 3.515l4.045 3.235H17.19V3.515Zm4.685 19.486H3.125V3.005h10.939V6.75c0 .329.08.654.238.957.157.303.387.579.677.81.586.47 1.38.733 2.21.733h4.686V23Z",
      fill: "#E6ACAA"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.189 15.952H7.808a1.78 1.78 0 0 0-1.105.366c-.293.235-.458.552-.458.884 0 .331.165.65.458.884.293.234.69.366 1.104.366h9.383a1.78 1.78 0 0 0 1.105-.366c.293-.235.457-.553.457-.884 0-.332-.164-.65-.457-.884a1.78 1.78 0 0 0-1.105-.366h-.001Z",
      fill: "#E6ACAA"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.808 10.951a1.78 1.78 0 0 0-1.105.367c-.293.234-.458.552-.458.883 0 .332.165.65.458.884.293.234.69.366 1.104.366h9.383a1.78 1.78 0 0 0 1.105-.366c.293-.235.457-.552.457-.884 0-.331-.164-.65-.457-.883a1.78 1.78 0 0 0-1.105-.367H7.807Z",
      fill: "#E6ACAA"
    }, null, -1)
  ]))]))
}
export default { render: render }